import _ from 'lodash';
import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { PipeDefinitionUtility } from 'v2/common/quantConfig';

const usePipeConfigsError = (pipes) => {
  const uniqueId = useMemo(() => 'pipes_based_error', []);
  const { errors, setError, clearErrors } = useFormContext();
  const error = _.get(errors, uniqueId, {});
  const errorMessage = error?.message || '';

  const pipeConfigsAccessibleError = (pipe, idx) => {
    const pipeType = _.get(pipe, 'type', '');
    const pipeConfig = PipeDefinitionUtility.getDefinitions()[pipeType];

    const isAccessible = _.has(pipeConfig, 'isAccessible') ? pipeConfig.isAccessible : true;

    if (isAccessible) return {};

    return {
      errorMessage: `Please purchase a Pro Plan to use ${_.capitalize(pipeType)} indicators.`,
      errorConfigs: {},
      isPremiumError: true,
      pipeIndex: idx
    };
  };

  useEffect(() => {
    const errorConfigs = {};
    _.forEach(pipes, (pipe, idx) => {
      errorConfigs[idx] = { pipeConfigs: pipeConfigsAccessibleError(pipe, idx), pipeIndex: idx };
    });

    const pipeIndex = _.find(errorConfigs, ({ pipeConfigs }) => !_.isEmpty(pipeConfigs))?.pipeIndex;
    if (!_.isUndefined(pipeIndex)) {
      setError(uniqueId, {
        type: 'custom',
        message: 'Please resolve the errors in the indicators',
        forceScrollTo: '.indicators-details .pipe_parent__view .error',
        pipeIndex,
        errorConfigs
      });
    } else {
      clearErrors(uniqueId);
    }

    return () => clearErrors(uniqueId);
  }, [clearErrors, uniqueId, setError, pipes]);

  return { errorMessage, errorConfigs: error?.errorConfigs || {} };
};

export default usePipeConfigsError;
